<template>
    <v-sheet
        id="step-body"
        class="overflow-y-auto overflow-x-hidden"
        :height="isLastStep ? 500 : bodyHeight"
    >
        <div class="mx-6">
            <StepDownload
                v-if="isLastStep"
                :isDownloadSuccess="isDownloadSuccess"
            />
            <StepMedia
                v-else-if="step.id === 'step_1'"
                :subtitle="step.subtitle"
                :description="step.description"
                :forms="filteredForms"
                :selectedMedia="selectedValues['media']"
            />
            <StepFormat
                v-else-if="step.id === 'step_2'"
                :subtitle="step.subtitle"
                :description="step.description"
                :forms="filteredForms"
                :selectedFormat="selectedValues['format']"
            />
            <StepQuality
                v-else-if="step.id === 'step_3'"
                :subtitle="step.subtitle"
                :description="step.description"
                :forms="filteredForms"
                :selectedValue="{
                    'media': selectedValues['media'],
                    'color': selectedValues['color'],
                    'quality': selectedValues['quality'],
                    'preset': selectedValues['preset']
                }"
                :selectedQuality="selectedValues['quality']"
                @set-properties="setAdvancedPresetProperties"
            />
            <StepOptions
                v-else-if="step.id === 'step_4'"
                :subtitle="step.subtitle"
                :description="step.description"
                :forms="filteredForms"
                :selectedOption="selectedValues['mention']"
                @update-disclaimer="updateDisclaimer"
            />
            <StepExport
                v-else-if="step.id === 'step_5' && !isDownloadStep"
                :step="step"
                :steps="steps"
                :selectedValues="selectedValues"
                @select-step="selectStep"
            />
        </div>

    </v-sheet>
</template>

<script>
    import StepMedia from '@/components/myHabiteoStudio/steps/StepMedia';
    import StepFormat from '@/components/myHabiteoStudio/steps/StepFormat';
    import StepQuality from '@/components/myHabiteoStudio/steps/StepQuality';
    import StepOptions from '@/components/myHabiteoStudio/steps/StepOptions';
    import StepExport from '@/components/myHabiteoStudio/steps/StepExport';
    import StepDownload from '@/components/myHabiteoStudio/steps/StepDownload';

    export default {
        name: 'Steps',
        components: {
            StepMedia,
            StepFormat,
            StepQuality,
            StepOptions,
            StepExport,
            StepDownload
        },
        props: {
            selectedValues: {
                type: Object,
                required: true
            },
            step: {
                type: Object,
                required: true
            },
            steps: {
                type: Array,
                required: true
            },
            isDownloadStep: {
                type: Boolean,
                required: true
            },
            isDownloadSuccess: {
                required: true
            }
        },
        computed: {
            filteredForms() {
                return this.$props.step.forms
            },
            isLastStep() {
                return this.$props.isDownloadStep && this.$props.isDownloadSuccess !== null;
            }
        },
        data: () => ({
            bodyHeight: 500
        }),
        methods: {
            setAdvancedPresetProperties(type, value) {
              this.$emit('set-properties', type, value);
            },
            selectStep(step) {
                this.$emit('select-step', step);
            },
            updateDisclaimer() {
                this.$emit('update-disclaimer');
            },
            setProperties(type, value) {
                this.$emit('set-properties', type, value);
            }
        },
        watch: {
            step() {
                this.bodyHeight = document.getElementById('mediaExportForm').offsetHeight - (document.getElementById('step-footer').offsetHeight + document.getElementById('step-summary').offsetHeight);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/Steps.vue